<template>
  <!-- 隐藏的文件输入（图片 / 视频） -->
  <input
    type="file"
    id="media-upload-input"
    accept="image/png,image/jpeg,image/jpg,image/webp,image/gif,video/mp4,video/quicktime,.mp4,.mov,audio/wav,audio/mpeg,.wav,.mp3"
    multiple
    class="hidden"
    @change="onFileChange"
  >

  <!-- 全局导航栏 -->
  <NavBar />

  <!-- 路由页面 -->
  <router-view />

  <!-- 素材展示页 -->
  <MaterialDetail />

  <!-- 视频预览模态框 -->
  <VideoModal />

  <!-- 全局确认弹窗 -->
  <ConfirmModal
    :visible="confirmState.visible"
    :title="confirmState.title"
    :message="confirmState.message"
    :confirm-text="confirmState.confirmText"
    :cancel-text="confirmState.cancelText"
    @confirm="modalHandleConfirm"
    @cancel="modalHandleCancel"
  />

  <!-- 全局 Toast -->
  <ToastContainer />

  <!-- 配额耗尽弹窗 -->
  <QuotaModal />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from './components/NavBar.vue'
import MaterialDetail from './components/MaterialDetail.vue'
import VideoModal from './components/VideoModal.vue'
import ConfirmModal from './components/ConfirmModal.vue'
import ToastContainer from './components/ToastContainer.vue'
import QuotaModal from './components/QuotaModal.vue'
import { setupReport, reportShow } from './util/report'
import { useModal } from './composables/useModal'
import { useAppStore } from './composables/useAppStore'
import { useAuth } from './composables/useAuth'
import type { PageId } from './types'

const route = useRoute()
const { confirmState, handleConfirm: modalHandleConfirm, handleCancel: modalHandleCancel } = useModal()
const { state, handleMediaUpload, switchTab, closeAllDropdowns, restoreDraftAfterLogin, loadQuota, loadActivity } = useAppStore()
const { checkLogin, authState } = useAuth()

const pageMap: Record<string, PageId> = { home: 'home', session: 'session' }
watch(() => route.name, (name) => {
  const key = name != null ? String(name) : ''
  if (key && pageMap[key]) state.currentPage = pageMap[key]
})

function onFileChange(e: Event) {
  const input = e.target as HTMLInputElement
  const files = input.files
  if (files && files.length > 0) {
    void handleMediaUpload(Array.from(files))
  }
  input.value = ''
}

function onGlobalClick(e: MouseEvent) {
  const t = e.target as HTMLElement
  if (!t.closest('.hero__dropdown-wrap') && !t.closest('.relative') && !t.closest('.session-page__mention-wrap')) {
    closeAllDropdowns()
  }
}

async function onVisibilityChange() {
  if (document.visibilityState !== 'visible') return
  const prevUserId = authState.userid
  const loggedIn = await checkLogin()
  if (!loggedIn && state.currentPage !== 'home') {
    window.location.href = '/aivideo/'
    return
  }
  if (prevUserId && authState.userid && authState.userid !== prevUserId) {
    window.location.href = '/aivideo/'
  } else if (loggedIn) {
    void loadQuota()
    await loadActivity()
  }
}

onMounted(async () => {
  setupReport()
  const initPage = route.name === 'session' ? 'detail' : 'index'
  reportShow(initPage)
  const loggedIn = await checkLogin()
  if (loggedIn) {
    restoreDraftAfterLogin()
    void loadQuota()
    await loadActivity()
  }
  switchTab('hot')
  window.addEventListener('click', onGlobalClick)
  document.addEventListener('visibilitychange', onVisibilityChange)
})

onUnmounted(() => {
  window.removeEventListener('click', onGlobalClick)
  document.removeEventListener('visibilitychange', onVisibilityChange)
})

</script>
